export const TRANSACTION_PREVIEW_DATA_SOURCE_ID = 'ToteumatDataSource'
export const EVENT_PROCESS_TO_TRANSACTION_PREVIEW_LIST_ID = 'TapahtumaKasittelyToteumaksiPreview'
export const EVENTS_LIST_DATA_SOURCE_ID = 'VuorotJaVapaatDataSource'
